import { render, staticRenderFns } from "./LatestAdmissions.vue?vue&type=template&id=d0f4d0e6&scoped=true&"
import script from "./LatestAdmissions.vue?vue&type=script&lang=js&"
export * from "./LatestAdmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f4d0e6",
  null
  
)

export default component.exports